import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { IconStarfull } from '@s4l/icons/IconStarfull'
import { useS4LContext } from '@s4l/react-context'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import styles from './styles.module.css'

export const REVIEW_ITEMS = 4

const renderStars = (rating: number): React.ReactNode => {
  return Array.from({ length: rating }, (_, starIndex) => (
    <IconStarfull key={`star-${starIndex}`} size={16} aria-hidden="true" />
  ))
}

function Reviews() {
  const { i18n } = useS4LContext()

  return (
    <div className={styles.container}>
      {Array.from({ length: REVIEW_ITEMS }).map((_, index) => {
        const reviewIndex = index + 1
        const userName = i18n.formatMessage({ id: `home.comment${reviewIndex}.username` })
        const rating = Number(i18n.formatMessage({ id: `home.comment${reviewIndex}.rating` }))

        return (
          <div key={`review-${userName}`} className={styles.review}>
            <Typography as="p" variant="body" size="l" bold>
              {userName}
            </Typography>
            <div className={styles.starsContainer}>{renderStars(rating)}</div>
            <Typography as="p" variant="caption" size="l">
              {i18n.formatMessage({
                id: `home.comment${reviewIndex}.text`,
              })}
            </Typography>
            <Button variant="text-flat" as="a" href="/reviews">
              {i18n.formatMessage({ id: 'global.read-more' })}
              <IconArrowRight size={16} />
            </Button>
          </div>
        )
      })}
    </div>
  )
}

Reviews.displayName = 'Reviews'
export default withErrorBoundary(Reviews)
